import mom from 'moment-timezone';

export default function moment(date) {
  return mom.utc(date).local();
}

moment.api = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  return mom.utc(date).format(format);
};
